/* eslint-disable @typescript-eslint/no-this-alias */
import React from 'react';
import axios from 'axios';
import { Box, CircularProgress, Grid, InputAdornment, TextField, Typography } from '@mui/material';
import AutocompleteBaseInput from '../myspace/common/inputs/AutocompleteBaseInput.jsx';
import { uniqueId } from '../../utils.js';

let cancelToken;

export default class ExternalCRMCompaniesSelector extends React.Component {
    constructor(props) {
        super(props);

        this.inputRef = null;
        this.search_timeout = null;

        this.initial_state = {
            loading: false,
            isSelected: false,
            open: false,
            companies: [],
            selectedCompany: {},
            inputIdValue: ''
        }

        this.state = {
            ...this.initial_state,
        };

        this.inputStyles = {
            input: {
                borderRadius: '0.38rem',
                height: '40px!important',
                maxHeight: '40px!important',
            },
            "& .MuiAutocomplete-input": {
                paddingTop: '0 !important',
                paddingBottom: '0 !important'
            },
            "& .MuiInputBase-root": {
                paddingTop: '.2rem !important',
                paddingBottom: '.2rem !important'
            },
        }

        this.handleSearch = this.handleSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);

        if(this.props.windowId && this.props.windowId !== '') {
            window.allExternalCRMCompaniesSelectors[this.props.windowId] = this;
        }

        document.addEventListener('js-nav-close', this.resetState);
    }

    removeEventListener() {
        document.removeEventListener('js-nav-close', this.resetState);
    }

    getSearchExternalCRMCompaniesParams = (query) => {
        if (typeof cancelToken != typeof undefined) {
            cancelToken.cancel("Operation canceled due to new request.")
        }
        cancelToken = axios.CancelToken.source()
        return {
            url: ENV.base_lang_url + "myspace/providers//ajaxGetter/external_crm_search_company/" + this.props.externalCrm,
            params: { 
                headers: {'Content-Type': 'multipart/form-data'},
                cancelToken: cancelToken.token
            },
            data: { external_crm_query: query }
        }
    }

    handleSearch(e, value, reason) {
        let _this = this;
        if (reason !== 'reset') {
            this.setState({ 
                companies: [],
                inputIdValue: '' 
            });
            if (this.search_timeout) clearTimeout(this.search_timeout);
            this.search_timeout = setTimeout(function() {
                const $errors = document.querySelector('#external-crm-companies-errors');
                if ($errors && $errors.firstElementChild) $errors.firstElementChild.remove();
                _this.searchExternalCRMCompany(value)
            }, 350);
        }
        if (reason === 'clear') this.props?.companyForm?.reset_membres_groups_form();
    }

    handleChange(e, newValue) {
        let inputIdValue = '';
        if (newValue) {
            inputIdValue = newValue.id;
            this.props?.companyForm?.prefill_membres_groups_form(newValue);
            this.inputRef.blur();
        }
        this.setState({ 
            inputIdValue,
            selectedCompany: newValue ?? {},
            open: false
        })
    }

    searchExternalCRMCompany = (q) => {
        const { selectedCompany } = this.state;
        if (q.length) {
            if (!Object.keys(selectedCompany ?? {}).length || q !== selectedCompany.name) {
                this.setState({
                    loading: true,
                    open: true
                });
            }
        } else {
            this.setState({
                loading: false,
                open: false
            });
        }

        const { url, data, params } = this.getSearchExternalCRMCompaniesParams(q);
        axios.post(url, data, params) 
        .then(response => {
            const companies = response.data;
            this.setState({ 
                loading: false,
                companies
            });
            if (this.search_timeout) clearTimeout(this.search_timeout);
        });
    }

    resetState = (e) => {
        if (this.inputRef && this.props.sectionTag && e.detail?.current_tag && this.props.sectionTag === e.detail.current_tag) {
            this.setState({ ...this.initial_state });
        }
    }

    getOptionLabel= (company) => {
        let label = '';
        if (typeof company === 'object' &&  Object.keys(company).length) {
            label = company.name;
        }
        return label;
    }

    render() {
        const { 
            loading,
            isSelected,
            open,
            companies,
            selectedCompany,
            inputIdValue
        } = this.state;

        const componentId = "external-crm-companies-selector-" + uniqueId();
        let required_attributes = {};
        if (this.props.required && (!selectedCompany || selectedCompany.id !== 0)) {
            required_attributes['data-parsley-required'] = true;
            required_attributes['data-parsley-error-message'] = this.props.trad.required_error_message;
            required_attributes['data-parsley-errors-container'] ="#external-crm-companies-errors";
        }

        return (
            <>
                { this.props.label && (
                    <label htmlFor={componentId}>
                        <i className="fa-regular fa-briefcase mr-1"></i>
                        {this.props.label}
                    </label>
                )}
                <AutocompleteBaseInput
                    id={componentId}
                    freeSolo={true}
                    getOptionLabel={(company) => this.getOptionLabel(company)}
                    filterOptions={(x) => x}
                    options={companies}
                    autoComplete={true}
                    includeInputInList={true}
                    filterSelectedOptions={true}
                    value={selectedCompany}
                    onChange={this.handleChange}
                    onInputChange={this.handleSearch}
                    loading={loading}
                    open={open}
                    ListboxProps={{
                        style: {
                            padding: 0
                        }
                    }}
                    renderInput={(params) => {
                        const iconAdornment = isSelected ? {
                            endAdornment: (
                                <React.Fragment>
                                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </React.Fragment>
                            )
                        } : !params.inputProps.value ? {
                            endAdornment: (
                                <React.Fragment>
                                    <InputAdornment position='end' sx={{ marginRight: '-1.5rem' }}>
                                        <i className="far fa-search"></i>
                                    </InputAdornment>
                                </React.Fragment>
                            )
                        } : {};

                        return (
                            <TextField 
                                {...params}
                                hiddenLabel
                                fullWidth
                                sx={this.inputStyles}
                                inputRef={(input) => this.inputRef = input}
                                onFocus={() => this.setState({ isSelected : true })}
                                onBlur={() => this.setState({ isSelected : false })}
                                InputProps={{
                                    ...params.InputProps,
                                    ...iconAdornment,
                                    onKeyDown: (e) => {
                                        if (loading) e.stopPropagation();
                                    }
                                }}
                            />
                        );
                    }}
                    renderOption={(props, company) => {
                        return (
                            (company.name) && (
                                <li {...props} key={uniqueId()} style={{ minHeight: '3rem' }}>
                                    <Grid container alignItems="center">
                                        <Grid item>
                                            <Box component="span" sx={!(!!company.id) ? { fontWeight: 'bold', color: '#F0672F', 'background': '' } : {}}>
                                                { company.name }
                                            </Box>

                                            { !!company.id && (
                                                <Typography variant="body2" color="text.secondary">
                                                    { company.external_crm_code && (
                                                        <Box component="span" className="d-flex align-items-center">
                                                            <i className='fa-regular fa-id-card mr-1'></i>
                                                            <span>{company.external_crm_code}</span>
                                                        </Box>
                                                    )}
                                                    { company.city && (
                                                        <Box component="span" className="d-inline-flex align-items-center">
                                                            <i className="fa-solid fa-location-dot mr-1"></i>
                                                            <span>{company.city}</span>
                                                        </Box>
                                                    )}
                                                </Typography>
                                            )}
                                        </Grid>
                                    </Grid>
                                </li>
                            )
                        );
                    }}
                />
                <div id="external-crm-companies-errors"></div>

                <input
                    type="hidden"
                    id={this.props.id}
                    name={this.props.name}
                    defaultValue={inputIdValue}
                    {...required_attributes}
                />
            </>
        );
    }
}

if(typeof window.allExternalCRMCompaniesSelectors == 'undefined') {
    window.allExternalCRMCompaniesSelectors = {};
}
